import { useTranslation } from 'react-i18next';
import CategoryCard from '@/components/feature/CategoryCard';
import { categories, videos } from '@/mocks/videos';

export default function CategoriesSection() {
  const { t } = useTranslation();

  const catsWithCount = categories.map((cat) => ({
    ...cat,
    count: videos.filter((v) => v.category === cat.slug).length,
  }));

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-6">
        <i className="ri-grid-line text-accent-500 mr-2"></i>
        {t('categories.title')}
      </h2>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-10 gap-3 md:gap-4">
        {catsWithCount.map((cat) => (
          <CategoryCard
            key={cat.slug}
            name={cat.name}
            slug={cat.slug}
            icon={cat.icon}
            count={cat.count}
          />
        ))}
      </div>
    </section>
  );
}